// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d6b7d2d","453":"2e82c4dd","455":"36ac4190"}[chunkId] + ".chunk.js";
};